import { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Alert,
  CircularProgress
} from "@mui/material";
import CommonButton from "../../components/CommonButton/CommonButton";
import axios from "axios";
import { reportTypes } from "../../utils/constants";
import { getUserEmail } from "../../utils/commonFunctions";

const apiEndpoint = process.env.REACT_APP_API_BASE_URL;

interface BusinessReportsPageProps {
  businessId: string;
}

const BusinessReportsPage: React.FC<BusinessReportsPageProps> = ({
  businessId
}) => {
  const [selectedReportType, setSelectedReportType] = useState(
    reportTypes[0].value
  );
  const [isGenerating, setIsGenerating] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({
    message: "",
    type: ""
  });

  const handleGenerateReport = async () => {
    if (!businessId || !selectedReportType) return;

    setIsGenerating(true);
    setNotificationMessage({
      message: "",
      type: ""
    });

    try {
      const accessToken = localStorage.getItem("accessToken") || "";
      const reportName = selectedReportType.toLowerCase().replace(/\s+/g, "");

      const config: any = {
        method: "post",
        url: `${apiEndpoint}/loyaltyprogram/loyaltyprograms/business/${businessId}/report/${reportName}`,
        headers: {
          Authorization: `bearer ${accessToken}`,
          "Content-Type": "application/json"
        },
        data: ""
      };

      const response = await axios(config);
      console.log(JSON.stringify(response.data));

      // Get user email for the success message
      const userEmail = await getUserEmail();
      console.log("User email retrieved:", userEmail);

      setNotificationMessage({
        message: `Report will be emailed to ${userEmail} shortly.`,
        type: "success"
      });
    } catch (err: any) {
      console.log(err);
      setNotificationMessage({
        message: err.response?.data?.message || "Failed to generate report",
        type: "error"
      });
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div>
      {notificationMessage?.message && (
        <div style={{ marginBottom: "20px" }}>
          <Alert severity={notificationMessage?.type as any}>
            {notificationMessage?.message}
          </Alert>
        </div>
      )}

      <div style={{ marginBottom: "20px" }}>
        <h3>Generate Business Reports</h3>
        <Typography
          variant="body2"
          color="text.secondary"
          style={{ marginBottom: "20px" }}
        >
          Select a report type and generate it. The report will be sent to your
          email address.
        </Typography>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <FormControl fullWidth style={{ maxWidth: "400px" }}>
          <InputLabel id="report-type-label">Report Type</InputLabel>
          <Select
            labelId="report-type-label"
            value={selectedReportType}
            label="Report Type"
            onChange={(e) => setSelectedReportType(e.target.value)}
            disabled={isGenerating}
          >
            {reportTypes?.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <CommonButton
          onClick={handleGenerateReport}
          disabled={isGenerating}
          isLoading={isGenerating}
        >
          {isGenerating ? (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={20} color="inherit" />
              Generating Report...
            </Box>
          ) : (
            "Generate Report"
          )}
        </CommonButton>
      </div>
    </div>
  );
};

export default BusinessReportsPage;
